import { Injectable } from '@angular/core';
import { fallbackDate, fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { Notification } from 'src/app/models/domain';
import { YPMNOTIFICATIONSRVHeader } from 'src/generated-clients/notification';
import { NotificationItemAdapter } from './notification-item-adapter';

@Injectable({
  providedIn: 'root',
})
export class NotificationAdapter implements IAdapter<Notification, YPMNOTIFICATIONSRVHeader> {
  public constructor(private readonly notificationItemAdapter: NotificationItemAdapter) {}

  public adaptToDomain(item: YPMNOTIFICATIONSRVHeader): Notification {
    return new Notification(
      fallbackString(item.notificationNumber),
      fallbackString(item.notificationType),
      fallbackString(item.notificationTypeText),
      fallbackString(item.systemStatus),
      fallbackString(item.assembly),
      fallbackString(item.shortText),
      fallbackString(item.createdTime),
      fallbackString(item.createdBy),
      fallbackString(item.objectNumber),
      fallbackString(item.equipmentNumber),
      fallbackString(item.maintenancePlanningPlant),
      fallbackString(item.notificationTime),
      fallbackString(item.mouldStatus),
      fallbackString(item.reportingPerson),
      fallbackString(item.mouldStatusText),
      fallbackString(item.orderNumber),
      fallbackString(item.elementStatus),
      fallbackString(item.priority),
      fallbackString(item.elementStatusText),
      fallbackString(item.priorityText),
      fallbackString(item.catalogType),
      fallbackString(item.codeGroup),
      fallbackString(item.coding),
      fallbackString(item.codingText),
      fallbackString(item.workCenter),
      fallbackString(item.workCenterText),
      fallbackString(item.startMalfunctionTime),
      fallbackString(item.endMalfunctionTime),
      item.breakdownDuration ?? 0,
      fallbackString(item.breakdownDurationUnit),
      fallbackString(item.location),
      fallbackString(item.locationText),
      fallbackString(item.room),
      Boolean(item.longTextExists),
      fallbackString(item.longText),
      fallbackDate(item.createdDate),
      fallbackDate(item.notificationDate),
      fallbackDate(item.startMalfunctionDate),
      fallbackDate(item.endMalfunctionDate),
      item.toItems?.results?.map((log) => this.notificationItemAdapter.adaptToDomain(log)) ?? []
    );
  }
}
